import animate from './animate' // 引入指令

export default (app)=>{
    animate(app)
}
